
import { useNavigate } from "react-router-dom";
import { GameBlock } from "./GameBlock";
import styles from "./Games.module.scss";
import { AppContext } from "../../components/Menu/MenuButton";
import wheelIcon from './icons/wheel.png';

enum Games {
    WheelOfFortune = 'wheel-of-fortune'
}

export const GamesList = () => {
    const navigate = useNavigate();

    const runGame = (game: Games) => navigate(`/${AppContext.Game}/${game}`);

    return (
        <div className={styles.gamesWrapper}>            
            <GameBlock name='Колесо Фортуны' icon={wheelIcon} handler={() => runGame(Games.WheelOfFortune)} />
        </div>
    );
}